<template>
  <div class="tw-flex tw-gap-2">
    <button
      @click="exportSepa('xml')"
      class="tw-text-secondary-500 hover:tw-text-green-500 hover:tw-border hover:tw-border-secondary-600 tw-transition-colors tw-rounded-full"
    >
      <XmlIcon class="tw-w-5 tw-h-5" />
    </button>
    <button
      @click="exportSepa('pdf')"
      class="tw-text-secondary-500 hover:tw-text-red-500 hover:tw-border hover:tw-border-secondary-600 tw-transition-colors tw-rounded-full"
    >
      <PdfIcon class="tw-w-5 tw-h-5" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toast-notification';
import XmlIcon from '@/assets/icons/XmlIcon.svg';
import PdfIcon from '@/assets/icons/PdfIcon.svg';
import { useSepaStore } from '@/stores/sepa.store';

const { exportSepaPayments } = useSepaStore();

const { t } = useI18n();
const toast = useToast();

const props = defineProps<{
  sepaPayments: any;
}>();

const exportSepa = async (format: 'xml' | 'pdf') => {
  await exportSepaPayments([props.sepaPayments.id], format);
  toast.open({
    message: t('sepa_payments.text.request_processing'),
    type: 'success',
  });
};
</script>
